import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

const Wrap = styled.div`
	margin-top: 60px;
`;
const DayList = styled.div<{isFixed?: boolean}>`
	position: sticky;
	top: 140px;
	width: 100%;
	margin-top: 20px;
	margin-left: 1px;
	border-bottom: 1px solid var(--line-color);
	background-color: #fff;
	z-index: 5;

	ul {
		position: relative;
		display: flex;
		height: 60px;
		overflow-x: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}

		li:first-child {
			a {
				margin-left: 0;
			}
		}

		li:last-child {
			a {
				margin-right: 0;
			}
		}
	}

	${props =>
		props.isFixed === false &&
		`
		position: static;
	`}
`;

const DayListItem = styled.a<{isActive: boolean}>`
	position: relative;
	display: flex;
	height: 100%;
	margin: 0 15px;
	color: var(--gray-color);
	white-space: nowrap;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	letter-spacing: -0.6px;

	${props =>
		props.isActive &&
		`	
			color: var(--emp-color);
			 &:before {
				 position: absolute;
				 bottom: 0;
				 left:0;
				 width: 100%;
				 height: 2px;
				 background-color:var(--yellow-color);
				 content: "";
			 }
		 `}
`;

const SubTitleWrap = styled.div`
	margin: 60px 0 20px;
	@media print {
		h3 {
			font-size: 36px;
		}
		+ div {
			h4 {
				font-size: 24px;
			}
			p {
				font-size: 20px;
			}
		}
	}
`;
const NoteBox = styled.div``;

const ScheduleBox = styled.ul`
	max-width: 910px;
	margin: 40px auto 0;
	border: 1px solid var(--line-color);

	> li:not(:first-child) {
		margin-top: 40px;
	}
`;

const ScheduleIitem = styled.li`
	scroll-margin: 200px;
`;

const ScheduleContent = styled.div`
	padding: 0 40px;
	margin-bottom: 40px;
`;

const ScheduleTitle = styled.div`
	display: flex;
	padding: 16px 40px 15px;
	background-color: var(--disabled-color);
	align-items: baseline;

	h3 {
		font-family: "PT-medium";
		font-size: 20px;
		color: var(--emp-color);
	}

	span {
		margin-left: 12px;
	}

	@media print {
		h3 {
			font-size: 30px;
		}

		span {
			font-size: 28px;
		}
	}
`;

const FlightTimeBox = styled.div`
	display: flex;
	margin: 40px 0 36px;
	justify-content: center;
`;

const Departure = styled.div`
	display: inline-flex;
	flex-direction: column;
	line-height: 1;
	align-items: end;
	flex-shrink: 0;
`;

const Arrival = styled.div`
	display: inline-flex;
	flex-direction: column;
	line-height: 1;
	align-items: start;
	flex-shrink: 0;
`;

const FlightCountry = styled.span`
	font-size: 16px;
	color: var(--emp-color);

	@media print {
		font-size: 24px;
	}
`;

const FlightTime = styled.span`
	margin-top: 10px;
	font-size: 28px;
	font-family: "PT-medium";
	color: var(--emp-color);

	@media print {
		font-size: 30px;
	}
`;

const FlightDate = styled.span`
	display: flex;
	height: 22px;
	margin-top: 10px;
	align-items: center;

	@media print {
		font-size: 22px;
	}
`;

const FlightIconBox = styled.div`
	position: relative;
	width: 368px;
	margin: 0 20px;

	span {
		position: absolute;
		top: 50%;
		left: 0;
		display: block;
		height: 4px;
		width: 100%;
		background-color: #f3f3f3;
		transform: translateY(-50%);

		&:before {
			position: absolute;
			left: 50%;
			top: 50%;
			width: 59px;
			height: 22px;
			background: #fff url(${SpriteImage}) no-repeat 0 -350px;
			transform: translate(-50%, -50%);
			content: "";
		}
	}

	&:before,
	&:after {
		position: absolute;
		top: 50%;
		z-index: 1;
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		border: 5px solid #daecfe;
		background-color: #3094fb;
		transform: translateY(-50%);
		content: "";
	}

	&:before {
		left: 0;
	}

	&:after {
		right: 0;
	}
`;

const AddDate = styled.span`
	display: inline-flex;
	padding: 0px 10px;
	height: 20px;
	margin-left: 10px;
	margin-top: 3px;
	border: 1px solid var(--red-color);
	border-radius: 12px;
	font-size: var(--small-size);
	color: var(--red-color);
	align-items: center;
`;

const MeetingInfoBox = styled.div`
	margin: 37px 0 42px;
	padding: 40px;
	border: 1px solid #ddd;

	h4 {
		position: relative;
		padding-left: 45px;
		font-size: 20px;
		font-family: "PT-medium";
		color: var(--emp-color);

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			width: 25px;
			height: 26px;
			background: #fff url(${SpriteImage}) no-repeat -194px 0px;
			transform: translateY(-50%);
			content: "";
		}
	}

	@media print {
		h4 {
			font-size: 26px;
		}
	}
`;

const MeetingList = styled.div`
	display: flex;
	margin-top: 22px;
	gap: 13px;
	flex-direction: column;
	line-height: 1;

	dl {
		display: flex;

		dt {
			font-size: 16px;
			color: var(--emp-color);

			&:after {
				display: inline-block;
				margin: 0 16px 0 18px;
				width: 1px;
				height: 12px;
				background-color: var(--line-color);
				content: "";
			}
		}

		dd {
			font-size: 16px;
		}
	}
	@media print {
		dl {
			dt,
			dd {
				font-size: 24px;
			}
			dt {
				&:after {
					height: 16px;
				}
			}
		}
	}
`;

const MeetingEdior = styled.div`
	margin-top: 32px;
	margin-bottom: 10px;
	padding-top: 30px;
	border-top: 1px dashed var(--line-color);
	text-align: center;

	> div {
		text-align: left;
		margin-bottom: 16px;
	}

	@media print {
		font-size: 26px;
	}
`;

const StepWrap = styled.div`
	position: relative;

	&:before {
		position: absolute;
		left: 15px;
		display: block;
		width: 4px;
		height: 100%;
		background-color: #eaeaea;
		content: "";
	}
`;

const Location = styled.div``;

const LocationTitle = styled.h4`
	position: relative;
	padding-left: 60px;
	margin-top: 30px;
	font-size: 20px;
	font-family: "PT-medium";
	color: var(--emp-color);

	&:before {
		position: absolute;
		z-index: 1;
		top: -5px;
		left: -3px;
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background-color: #fff;
		box-shadow: 0 0 10px 0 #eaeaea;
		content: "";
	}

	i {
		position: relative;

		&:before {
			position: absolute;
			z-index: 2;
			top: 4px;
			left: -51px;
			display: block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			border: 4px solid #3094fb;
			background-color: #fff;
			content: "";
		}

		&:after {
			position: absolute;
			z-index: 2;
			top: 16px;
			left: -50px;
			display: block;
			width: 0;
			height: 10px;
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			border-top: 9px solid #3094fb;
			transform-origin: 0 100%;
			content: "";
		}
	}

	span {
		padding-left: 20px;
	}

	@media print {
		font-size: 30px;
		&:before {
			top: -1px;
		}
		i {
			&:before {
				top: 10px;
			}
			&:after {
				top: 22px;
			}
		}
	}
`;

const LocationText = styled.p`
	position: relative;
	padding-left: 60px;
	margin-top: 30px;

	&:before {
		position: absolute;
		top: 5px;
		left: 9px;
		z-index: 1;
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		border: 5px solid #daecfe;
		background-color: #3094fb;
		content: "";
	}

	span {
		margin-right: 10px;
	}

	@media print {
		font-size: 28px;
		&:before {
			top: 14px;
		}
	}
`;

const EditorBoxWrap = styled.div`
	margin: 12px 0 12px 60px;

	@media print {
		font-size: 24px;
		p,
		div p {
			font-size: 24px;
		}
	}
`;

const EditorGrayBoxWrap = styled.div`
	padding: 10px 15px;
	margin: 12px 0 12px 60px;
	border: 1px solid var(--line-color);
	background-color: var(--disabled-color);
	@media print {
		font-size: 24px;
		p,
		div p {
			font-size: 24px;
		}
	}
`;

const ImgBox = styled.div`
	margin: 40px 0;
	padding-left: 60px;

	img {
		width: 100%;
		vertical-align: top;
	}
`;

const StopoverIconBox = styled.div`
	position: relative;
	width: 474px;
	margin: 0 20px;

	span {
		position: absolute;
		top: 50%;
		left: 0;
		display: block;
		height: 4px;
		width: 100%;
		background-color: #f3f3f3;
		transform: translateY(-50%);
	}

	&:before,
	&:after {
		position: absolute;
		top: 50%;
		z-index: 1;
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		border: 5px solid #daecfe;
		background-color: #3094fb;
		transform: translateY(-50%);
		content: "";
	}

	&:before {
		left: 0;
	}

	&:after {
		right: 0;
	}

	@media print {
		font-size: 24px;
		span {
			font-size: 24px;
		}
	}
`;

const StopoverIcon = styled.div`
	position: absolute;
	left: 50%;
	display: flex;
	font-size: var(--basic-size);
	color: #3094fb;
	transform: translateX(-50%);
	align-items: center;
	gap: 8px;

	&:before {
		display: inline-block;
		width: 39px;
		height: 22px;
		background: #fff url(${SpriteImage}) no-repeat -10px -350px;
		content: "";
	}
`;

const TransitWrap = styled.div`
	position: absolute;
	top: 35px;
	left: 0;
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: 110px;
`;

const TransitText = styled.div`
	position: relative;
	display: flex;
	padding-top: 27px;
	flex-direction: column;
	line-height: 1;

	&:before {
		position: absolute;
		top: 0;
		left: 50%;
		z-index: 1;
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		border: 5px solid #d2d2d2;
		background-color: var(--default-color);
		transform: translateX(-50%);
		content: "";
	}
`;

const SummaryInfo = styled.div`
	display: flex;
	margin: 40px 0;
	padding-top: 36px;
	border-top: 1px dashed var(--line-color);
	flex-direction: column;
	gap: 7px;

	dl {
		display: flex;
		align-items: baseline;
	}

	dt {
		display: inline-flex;
		align-items: center;
		height: 20px;
		padding: 0 8px;
		border: 1px solid var(--bl-color);
		border-radius: 10px;
		background: #fff;
		font-size: 12px;
		color: var(--emp-color);
		line-height: 1;
		flex-shrink: 0;
	}

	dd {
		width: 100%;
		margin-left: 17px;
		line-height: 1.73;

		a {
			display: block;
			color: var(--blue-color);
			text-decoration: underline;
		}
	}

	@media print {
		dl {
			font-size: 26px;
			word-break: keep-all;
			dt {
				font-size: 20px;
				padding: 12px 10px;
				border-radius: 16px;
			}
			dd {
				font-size: 26px;
			}
		}
	}
`;

const MealList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 0 24px;

	> li {
		display: flex;
		word-break: keep-all;
	}
`;

const TemplateWrap = styled.div`
	margin: 40px 0 40px 60px;
`;

const PlayBox = styled.div`
	position: relative;
	height: 0;
	padding-top: 54.14%;
	margin: 40px 0 40px 60px;

	> div {
		position: absolute;
		top: 0;
	}
`;

export {
	Wrap,
	SubTitleWrap,
	NoteBox,
	ScheduleBox,
	ScheduleIitem,
	ScheduleContent,
	ScheduleTitle,
	FlightTimeBox,
	Departure,
	Arrival,
	FlightCountry,
	FlightTime,
	FlightDate,
	FlightIconBox,
	AddDate,
	MeetingInfoBox,
	MeetingList,
	MeetingEdior,
	StepWrap,
	Location,
	LocationTitle,
	LocationText,
	EditorBoxWrap,
	EditorGrayBoxWrap,
	DayList,
	DayListItem,
	ImgBox,
	StopoverIconBox,
	StopoverIcon,
	TransitWrap,
	TransitText,
	SummaryInfo,
	MealList,
	TemplateWrap,
	PlayBox,
};
